
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as appOLqiQ03SeG1uUFSEvH0TmYo0O2kPVEwEdq6VwMP2zDUMeta } from "/var/www/frontend/reviewapp-production/pages/app.vue?macro=true";
import { default as index8bvqZtv4F2Mj04fv_45EMQR0grYAY0fJbuqsAFsiksuQsMeta } from "/var/www/frontend/reviewapp-production/pages/index.vue?macro=true";
import { default as terms53Ff843Mhj6_45Fl5OAwODRJ3cmokm8fAosHKPllmMx9wMeta } from "/var/www/frontend/reviewapp-production/pages/terms.vue?macro=true";
import { default as placesg4zL_J_0eC_45qqNdnC7WmNpGiBw_4s4_45SCJCngz13lZYMeta } from "/var/www/frontend/reviewapp-production/pages/places.vue?macro=true";
import { default as expertsPpWGyid_ZsCeguXR5FWcmW7Pz1_mCuEY94zhF59kzDAMeta } from "/var/www/frontend/reviewapp-production/pages/experts.vue?macro=true";
import { default as pricing0Lm8ekSbD7qoCwWMZLVO79Gzd_nZk7HSUBgorzZz04UMeta } from "/var/www/frontend/reviewapp-production/pages/pricing.vue?macro=true";
import { default as privacyYyazT3_EQU7TmbwM2lonqhd4TptxNLTIXHAWRwsyhXgMeta } from "/var/www/frontend/reviewapp-production/pages/privacy.vue?macro=true";
import { default as suggestVffXhJUg_bnpL24B5magGbAUFiNY5Qd4fhDdRIvvST8Meta } from "/var/www/frontend/reviewapp-production/pages/suggest.vue?macro=true";
import { default as _91_46_46_46404_93Bjd3cb6SZMqXW1ql0_45CUBOoSzNBAt4OZfGLoFNfs4RYMeta } from "/var/www/frontend/reviewapp-production/pages/[...404].vue?macro=true";
import { default as about_45uswYHM1IlrHuEhpMaC6FIVxQsf92E5quzhkGbDPaXtAMMMeta } from "/var/www/frontend/reviewapp-production/pages/about-us.vue?macro=true";
import { default as businessKhtxNxPd2krKgEz8BnQwiXLrR2b6L_45CBgVTf0OHaaQwMeta } from "/var/www/frontend/reviewapp-production/pages/business.vue?macro=true";
import { default as my_45ordersj4a_crvDSnsyn6AcJpptOtbt75EvpJqZT_45e1xodMOTEMeta } from "/var/www/frontend/reviewapp-production/pages/my-orders.vue?macro=true";
import { default as categoriesFosrZ_45jfpyfOW9OwPe8h_XJ3BfJ9KwfhkEU6kKdz9IEMeta } from "/var/www/frontend/reviewapp-production/pages/categories.vue?macro=true";
import { default as contact_45ussZz31XScmQ0N4Vt9nq_451g4bOGWzMYs52sGnv1cxnPcYMeta } from "/var/www/frontend/reviewapp-production/pages/contact-us.vue?macro=true";
import { default as profilecbGtXzBgy8KRz2cCHtVBrM7lijWFBGKgllutM9w_5eIMeta } from "/var/www/frontend/reviewapp-production/pages/user/profile.vue?macro=true";
import { default as my_45ratesd64RVPUVdD4ldIp4_45AQQEGQ_45h5IRwUpx2mvXyt_45JStEMeta } from "/var/www/frontend/reviewapp-production/pages/user/my-rates.vue?macro=true";
import { default as _91tenant_93CmEF6N8Ff4gI81SYTcsY8v0KLxUfIQ1loflQv5LCeREMeta } from "/var/www/frontend/reviewapp-production/pages/place/[tenant].vue?macro=true";
import { default as indexsFN_45eUmAYDK_wYnUyQ_Btq3KefxzZIhSI1O1N9BRBQcMeta } from "/var/www/frontend/reviewapp-production/pages/services/index.vue?macro=true";
import { default as summarycIIHj_BEwV5NDjKHBIMKQcGCaoiIaXPtPfUuyQRWd4cMeta } from "/var/www/frontend/reviewapp-production/pages/services/summary.vue?macro=true";
import { default as _91slug_93erP23Gou_454V7f8H5W0mufUTcgK192ws0zDGrDzUl86UMeta } from "/var/www/frontend/reviewapp-production/pages/category/[id]/[slug].vue?macro=true";
import { default as _91slug_936_45Jx2y0zRmrE3_45GDbfqMEjmlpVbjxwBZK5wfjYwrzkwMeta } from "/var/www/frontend/reviewapp-production/pages/place/[place_id]/[slug].vue?macro=true";
import { default as _91name_93yRLDaFX2sCk2TYTd7ZdwSpYz3N7NVT7MeUiizLuBzT4Meta } from "/var/www/frontend/reviewapp-production/pages/services/details/[name].vue?macro=true";
import { default as complete_45paymenta1Aux7_SlcdqnWD0djT94B_45JW6ciMXHYSGadiaHAqzcMeta } from "/var/www/frontend/reviewapp-production/pages/services/complete-payment.vue?macro=true";
import { default as _91slug_93GTA3uEzWBocP0Trd6A_45ZpRsVlv6YyAvhm5IlKYn0haEMeta } from "/var/www/frontend/reviewapp-production/pages/user-profile/[user_id]/[slug].vue?macro=true";
export default [
  {
    name: "app",
    path: "/app",
    component: () => import("/var/www/frontend/reviewapp-production/pages/app.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/frontend/reviewapp-production/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/var/www/frontend/reviewapp-production/pages/terms.vue")
  },
  {
    name: "places",
    path: "/places",
    component: () => import("/var/www/frontend/reviewapp-production/pages/places.vue")
  },
  {
    name: "experts",
    path: "/experts",
    component: () => import("/var/www/frontend/reviewapp-production/pages/experts.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/var/www/frontend/reviewapp-production/pages/pricing.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/var/www/frontend/reviewapp-production/pages/privacy.vue")
  },
  {
    name: "suggest",
    path: "/suggest",
    component: () => import("/var/www/frontend/reviewapp-production/pages/suggest.vue")
  },
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/var/www/frontend/reviewapp-production/pages/[...404].vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/var/www/frontend/reviewapp-production/pages/about-us.vue")
  },
  {
    name: "business",
    path: "/business",
    component: () => import("/var/www/frontend/reviewapp-production/pages/business.vue")
  },
  {
    name: "my-orders",
    path: "/my-orders",
    component: () => import("/var/www/frontend/reviewapp-production/pages/my-orders.vue")
  },
  {
    name: "categories",
    path: "/categories",
    component: () => import("/var/www/frontend/reviewapp-production/pages/categories.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/var/www/frontend/reviewapp-production/pages/contact-us.vue")
  },
  {
    name: "user-profile",
    path: "/user/profile",
    component: () => import("/var/www/frontend/reviewapp-production/pages/user/profile.vue")
  },
  {
    name: "user-my-rates",
    path: "/user/my-rates",
    component: () => import("/var/www/frontend/reviewapp-production/pages/user/my-rates.vue")
  },
  {
    name: "place-tenant",
    path: "/place/:tenant()",
    component: () => import("/var/www/frontend/reviewapp-production/pages/place/[tenant].vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/frontend/reviewapp-production/pages/services/index.vue")
  },
  {
    name: "services-summary",
    path: "/services/summary",
    component: () => import("/var/www/frontend/reviewapp-production/pages/services/summary.vue")
  },
  {
    name: "category-id-slug",
    path: "/category/:id()/:slug()",
    component: () => import("/var/www/frontend/reviewapp-production/pages/category/[id]/[slug].vue")
  },
  {
    name: "place-place_id-slug",
    path: "/place/:place_id()/:slug()",
    component: () => import("/var/www/frontend/reviewapp-production/pages/place/[place_id]/[slug].vue")
  },
  {
    name: "services-details-name",
    path: "/services/details/:name()",
    component: () => import("/var/www/frontend/reviewapp-production/pages/services/details/[name].vue")
  },
  {
    name: "services-complete-payment",
    path: "/services/complete-payment",
    component: () => import("/var/www/frontend/reviewapp-production/pages/services/complete-payment.vue")
  },
  {
    name: "user-profile-user_id-slug",
    path: "/user-profile/:user_id()/:slug()",
    component: () => import("/var/www/frontend/reviewapp-production/pages/user-profile/[user_id]/[slug].vue")
  }
]